import { Component, OnInit, TemplateRef, HostListener, ViewChild, ElementRef } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LoginService } from '../../services/login.service';
import { ContactUsService } from "../../services/contactus.service";
import { Router } from '@angular/router';
import { ErrorModalComponent } from '../modals/error-modal/error-modal.component';
import { InfoModalComponent } from "../modals/info-modal/info-modal.component";
import { TranslateService } from '@ngx-translate/core';
import { AppConfig } from 'src/app/app.config';
import { fromEvent } from "rxjs";
import { ResendVerification } from '../modals/resend-verification/resend-verification.component';
import { environment } from 'src/environments/environment';
export enum KEY_CODE {
  ENTER_KEY = 13
}

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  public login: string;
  public password: string;
  public disable = false;
  public email: string;
  public cityName: string;
  public schoolName: string;
  private defaultDescription: string = "Hi Route2school, I noticed that my school is currently not listed as a project. This means that the city did not yet contact the route2school team. By sending this form, I support the Route2school initiative and I wish it could also be done in my city.";
  public extraInfo: string;
  public directContact = false;
  public loading = false;
  public sending = false;
  public autofilled = false;
  public showFacebookButton = environment.showFacebookButton;
  public projectName = environment.projectName;
  @ViewChild('passwordBox', { static: false }) passwordBox: ElementRef;

  constructor(
    private modalService: NgbModal,
    private loginService: LoginService,
    private contactService: ContactUsService,
    private router: Router,
    private translate: TranslateService,
    private configService: AppConfig
  ) {
  }

  get lang(): string {
    return this.translate.currentLang;
  }

  set lang(value: string) {
    localStorage.setItem('user_lng', value);
    this.translate.use(value);
  }

  getRedirectUrl(thirdParty) {
    if (thirdParty == 'apple') {
      return this.configService.getAppleUrl();
    }
    return this.configService.getRedirectUrl(thirdParty);
  }

  ngOnInit() {
    this.translate.stream(this.defaultDescription).subscribe(s => this.extraInfo = s);

    if (localStorage.getItem('user_id') && localStorage.getItem('token_info')) {
      this.router.navigate(['/', 'reports']);
    }

    setTimeout(() => {
      if (document.querySelector(':-webkit-autofill')) {
        this.autofilled = true;
      }
    }, 500);

    if (localStorage.getItem('profile-settings')) {
      localStorage.removeItem('profile-settings');
    }
  }

  openModal(forgotPasswordContent: TemplateRef<any>) {
    this.modalService.open(forgotPasswordContent);
  }

  signin() {
    this.disable = true;
    this.login = this.login.trim();
    this.loginService
      .login('', this.login, this.password)
      .subscribe(res => {
        const currentLang = localStorage.getItem('user_lng')
        localStorage.clear();
        localStorage.setItem('user_lng',currentLang)
        localStorage.setItem('token_info', JSON.stringify(res));
        localStorage.setItem('user_id', JSON.stringify(this.login));
        this.disable = false;
        this.router.navigate(['/', 'help']);
      }, err => {
        this.disable = false;
        const errorObj = err.error;
        let errorMessage = '';
        switch (errorObj.status) {
          case 460:
            const infoDlg = this.modalService.open(ResendVerification);
            infoDlg.componentInstance.message = 'This account is not yet verified. Please verify the account before trying to log in.';
            infoDlg.componentInstance.email = this.login;
            infoDlg.componentInstance.language = this.lang;
            infoDlg.result.then(() => this.router.navigate(['/login']));
            break;
          case 500:
            errorMessage = 'An unexpected error has occurfed. Please try again later. If the error keeps occurring, please contact our support team.';
            break;
          default:
            errorMessage = errorObj.error
            break;
        }
        if (errorObj.status !== 460) {
          const infoDlg = this.modalService.open(ErrorModalComponent);
          infoDlg.componentInstance.message = errorMessage;
          if (errorObj.status === 403) {
            infoDlg.componentInstance.header = 'Failure!';
          }
        }
      });
  }

  get isDisableButton() {
    return (!(this.login && this.password) || this.disable) && !this.autofilled;
  }

  forgotPwd(modal) {
    this.sending = true;
    this.loginService.forgotPwd(this.email, this.lang).subscribe(() => {
      this.sending = false;
      modal.dismiss('confirm');
    }, err => {
      const errorObj = err.error;
      let errorMessage = '';
      let errorHeader = 'Verification error';
      if (errorObj.status === 500) {
        errorMessage = 'An unexpected error has occurfed. Please try again later. If the error keeps occurring, please contact our support team.';
      } else {
        errorMessage = errorObj.error
      }
      if (errorObj.status === 462) {
        errorHeader = 'Authorization error';
      }
      const infoDlg = this.modalService.open(InfoModalComponent);
      infoDlg.componentInstance.data = {
        text: errorMessage,
        header: errorHeader
      };
      this.sending = false;
    });
  }

  contactUs(modal) {
    this.loading = true;
    this.contactService.contactUs(this.email, this.cityName, this.schoolName, this.extraInfo, this.directContact).subscribe(
      res => {
        modal.dismiss('ok');
        this.email = "";
        this.schoolName = "";
        this.cityName = "";
        this.directContact = false;

        this.loading = false;

        const infoDlg = this.modalService.open(InfoModalComponent);
        infoDlg.componentInstance.data = {
          text: 'Thank you for contacting us. We will contact you shortly.',
          header: 'We received your request'
        };
      });
  }

  get isDisableContactUs() {
    return !this.login && !this.password || this.disable;
  }

  togglePassword(e) {


    if (e.target.classList.contains('fa-eye')) {
      e.target.classList.remove('fa-eye');
      e.target.classList.add('fa-eye-slash');
    }
    else {
      e.target.classList.remove('fa-eye-slash');
      e.target.classList.add('fa-eye');
    }

    if (this.passwordBox.nativeElement.type == 'password') {
      this.passwordBox.nativeElement.setAttribute('type', 'text');
    }
    else {
      this.passwordBox.nativeElement.setAttribute('type', 'password');
    }
  }

  @HostListener('window:keyup', ['$event'])
  keyEvent(event: KeyboardEvent) {

    if (event.keyCode === KEY_CODE.ENTER_KEY) {
      if (!this.isDisableButton) {
        this.signin();
      }
    }
  }
}
